import React from 'react';
import { motion } from 'framer-motion';

const CARD_HIDDEN_LEFT = { opacity: 0, x: -50 };
const CARD_HIDDEN_RIGHT = { opacity: 0, x: 50 };
const CARD_VISIBLE = { opacity: 1, x: 0 };
const CARD_TRANSITION = { duration: 0.8 };

const ICON_INITIAL = { scale: 0 };
const ICON_VISIBLE = { scale: 1 };
const ICON_TRANSITION = { delay: 0.3, type: 'spring' };

const AboutCard = ({
  Icon,
  title,
  description,
  isInView,
  direction,
  cardClass,
  titleGradient,
  iconClass
}) => {
  const cardInitial = direction === 'left' ? CARD_HIDDEN_LEFT : CARD_HIDDEN_RIGHT;
  const iconPosition = direction === 'left' ? '-top-6 -left-6' : '-top-6 -right-6';

  return (
    <motion.div
      initial={cardInitial}
      animate={isInView ? CARD_VISIBLE : cardInitial}
      transition={CARD_TRANSITION}
      className="relative"
    >
      <div className={`relative p-8 rounded-2xl backdrop-blur-sm border ${cardClass}`}>
        <motion.div
          initial={ICON_INITIAL}
          animate={isInView ? ICON_VISIBLE : ICON_INITIAL}
          transition={ICON_TRANSITION}
          className={`absolute ${iconPosition} p-4 rounded-xl shadow-lg ${iconClass}`}
        >
          <Icon className="w-8 h-8 text-white" />
        </motion.div>

        <h2 className="text-3xl md:text-4xl font-bold mb-6 mt-4">
          <span className={`bg-gradient-to-r ${titleGradient} bg-clip-text text-transparent`}>
            {title}
          </span>
        </h2>
        <p className="text-gray-300 text-lg leading-relaxed">
          {description}
        </p>
      </div>
    </motion.div>
  );
};

export default AboutCard;
